import ExcelJS from 'exceljs'
import xlsxPreview from 'xlsx-preview'

const TAB_BASE =
  'tw:cursor-pointer tw:border tw:border-border tw:px-2 tw:py-1 tw:-mr-px tw:bg-muted tw:text-sm'
const TAB_ACTIVE_BG = 'tw:bg-background'

const CONTENT_BASE = 'tw:w-full tw:overflow-x-auto tw:hidden'
const CONTENT_HIDDEN = 'tw:hidden'

export async function renderExcelPreview(
  arrayBuffer: ArrayBuffer,
  container: HTMLElement,
  signal: AbortSignal,
): Promise<void> {
  const workbook = new ExcelJS.Workbook()
  await workbook.xlsx.load(arrayBuffer)
  if (signal.aborted) return
  const sheetNames = workbook.worksheets.map(ws => ws.name)

  if (sheetNames.length === 0) {
    throw new Error('No worksheets found in the file')
  }

  const sheetHtmls = (await xlsxPreview.xlsx2Html(arrayBuffer, {
    separateSheets: true,
  })) as string[]

  if (signal.aborted) return

  const containerEl = document.createElement('div')

  const tabBar = document.createElement('div')
  tabBar.className = 'tw:flex tw:flex-wrap tw:mb-4'

  const tableArea = document.createElement('div')

  let activeTab: HTMLElement | null = null
  let activeContent: HTMLElement | null = null

  function activateSheet(
    tab: HTMLElement,
    content: HTMLElement,
    html: string,
  ): void {
    if (activeTab) activeTab.classList.remove(TAB_ACTIVE_BG)
    if (activeContent) activeContent.classList.add(CONTENT_HIDDEN)

    if (!content.hasChildNodes()) {
      content.innerHTML = html
    }

    tab.classList.add(TAB_ACTIVE_BG)
    content.classList.remove(CONTENT_HIDDEN)
    activeTab = tab
    activeContent = content
  }

  for (let i = 0; i < sheetHtmls.length; i++) {
    const tab = document.createElement('button')
    tab.type = 'button'
    tab.textContent = sheetNames[i] ?? `Sheet ${i + 1}`
    tab.className = TAB_BASE

    const content = document.createElement('div')
    content.className = CONTENT_BASE

    const html = sheetHtmls[i]

    tab.addEventListener('click', () => {
      activateSheet(tab, content, html)
    })

    if (i === 0) {
      activateSheet(tab, content, html)
    }

    tabBar.appendChild(tab)
    tableArea.appendChild(content)
  }

  containerEl.appendChild(tabBar)
  containerEl.appendChild(tableArea)

  container.replaceChildren(containerEl)
}
